import React from 'react';
import axios from "axios";

const url = "https://rampport-api.herokuapp.com";
const proxyUrl = "https://cors-anywhere.herokuapp.com/";



export const fetchBen = async () => {

  try {
    const { data }  = await axios.get( url + '/api/benjamin');
    console.log(data);

    const benData = {
      id: data[0].id,
      name: data[0].name,
      titles: data[0].titles,
      aboutPageTitles: data[0].aboutPageTitles,
      projectPageTitles: data[0].projectPageTitles,
      img: data[0].img,
      about: data[0].about,
      offers: data[0].offers,
      sampleProj: data[0].sampleProj,
      productMe: data[0].productMe,
      company: data[0].company,
      aboutPage: data[0].aboutPage,
      abouPageSect2: data[0].abouPageSect2,
      aboutPageSect3: data[0].aboutPageSect3,
      aboutPageSect4: data[0].aboutPageSect4,
      aboutPageSect5: data[0].aboutPageSect5,
      projPage: data[0].projPage,
      proj2Page: data[0].proj2Page,
      dataTargetPage: data[0].dataTargetPage,
      attendoPage: data[0].attendoPage,
    };
    return benData;
  } catch (err) {
    console.log(err);
  }
};
